export const EventTypes = {
    MoveToRepro: 'Move to Repro',
    Insemination: 'Insemination',
    Pregnant: 'Pregnant',
    NotPregnant: 'Not Pregnant',
    DryingOff: 'Drying Off',
    MoveToVWP: 'Move to Voluntary Waiting Period',
    Culled: 'Culled',
    Calving: 'Calving',
    Note: 'Note'
}


// WEBPACK FOOTER //
// ./src/constants/event_types.js